import { useState, useEffect } from 'react';
import { api } from '../api/client';

interface PriceCellProps {
    symbol: string;
    market: string;
    avgPrice: number;
}

export default function PriceCell({ symbol, market, avgPrice }: PriceCellProps) {
    const [currentPrice, setCurrentPrice] = useState<number | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;

        async function fetchPrice() {
            // Map market names to API format
            const apiMarket = market.includes('KO') || market === 'KOSPI' || market === 'KOSDAQ' || market === 'KRX' ? 'KRX' : 'US';
            const response = await api.getStockPrice(symbol, apiMarket);

            if (mounted && response.success) {
                setCurrentPrice(response.data.currentPrice);
            }
            if (mounted) {
                setLoading(false);
            }
        }

        fetchPrice();

        return () => {
            mounted = false;
        };
    }, [symbol, market]);

    if (loading) return <span className="text-muted text-sm">...</span>;
    if (!currentPrice || avgPrice === 0) return <span className="text-muted">-</span>;

    const pnlPct = ((currentPrice - avgPrice) / avgPrice) * 100;
    const isPositive = pnlPct >= 0;
    const formatted = pnlPct.toFixed(2);

    return (
        <span className={isPositive ? 'text-success' : 'text-danger'}>
            {isPositive ? '+' : ''}{formatted}%
        </span>
    );
}
